import React from 'react';
import {TextInput, Button, Group, Box, Grid, Select} from '@mantine/core';
import {useForm} from '@mantine/form';
import {supportedCountries} from "../../common/Mantine.form/Address/Address.types";


interface Props {
    onSubmitQuery?: (query: any) => void,
    initialValues?: any
}

interface FormValues {
    AgentName: string,
    Email: string,
    CountryCode: string,
    AgentStatus: string
}

function AgentFilters({onSubmitQuery, initialValues}: Props) {
    const form = useForm<FormValues>({
        initialValues: initialValues || {
            AgentName: "",
            Email: "",
            CountryCode: "",
            AgentStatus: "",
        },
        validate: {
            /*AgentName: (value) => (value !== null && value !== "" && value.length <= 60 ? null : 'Up to 60 characters allowed.'),
            Country: (value) => (value !== null && value !== "" && value.length <= 2 ? null : 'Up to 2 characters allowed.'),
            Email: (value) => (value !== null && value !== "" && /^\S+@\S+$/.test(value) && value.length <= 100 ? null : 'Invalid email format. Up to 100 characters allowed.')
            */
        },
    });

    function onSubmit(values: typeof form.values) {
        if (onSubmitQuery){
            onSubmitQuery(values)
        }
    }

    function getSupportedCountriesData() {
        return Object
            .keys(supportedCountries(form))
            .map(key => ({value: key, label: supportedCountries(form)[key].display}))
    }

    return (
        <div className='agent-filters'>
            <Box mx="auto">
                <form onSubmit={form.onSubmit(onSubmit)}>
                    <Grid>
                        <Grid.Col sm={6} lg={3}>
                            <TextInput
                                label="Agent Name"
                                placeholder="Agent Name"
                                {...form.getInputProps('AgentName')}
                            />
                        </Grid.Col>
                        <Grid.Col sm={6} lg={3}>
                            <TextInput
                                label="Email"
                                placeholder="Email"
                                {...form.getInputProps('Email')}
                            />
                        </Grid.Col>
                        <Grid.Col sm={6} lg={3}>
                            <Select
                                label="Country"
                                placeholder="Please select a Country"
                                clearable
                                searchable
                                {...form.getInputProps("CountryCode")}
                                data={getSupportedCountriesData()}/>
                        </Grid.Col>
                        <Grid.Col sm={6} lg={3}>
                            <Select
                                label="Agent Status"
                                placeholder="Agent Status"
                                clearable
                                searchable
                                data={[
                                    { value: 'Approved', label: 'Approved' },
                                    { value: 'Denied', label: 'Denied' },
                                    { value: 'Pending Review', label: 'Pending Review' },
                                ]}
                                {...form.getInputProps('AgentStatus')}
                            />
                        </Grid.Col>
                    </Grid>
                    <Group position="right" mt="md">
                        <Button type="submit">Search</Button>
                    </Group>
                </form>
            </Box>
        </div>
    )
}

export default AgentFilters;